module.exports = __webpack_public_path__ + "static/media/devkit-board.f84348e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/devkit-board.png
// module id = 524
// module chunks = 0